module.exports = __webpack_public_path__ + "static/media/movimentacao.20306c23.png";